<template>
	<div
		class="relative flex items-center justify-center bg-center p-6 md:max-h-[380px] md:p-10"
	>
		<NuxtImg
			:provider="getProvidedImageHandler()"
			:src="getUrlFromStaticDNS('/images/off-market-card-bg.jpg')"
			class="absolute z-10 size-full grayscale"
			width="500"
		/>
		<Card
			class="z-20 flex h-[215px] flex-col justify-center bg-white md:h-[288px]"
		>
			<CardHeader class="px-5 pb-3 pt-7">
				<CardTitle
					class="flex items-center text-xl font-light text-primary md:text-2xl"
				>
					<GraphicsTriangle class="mr-4 size-4 md:h-5 md:w-[19px]" /> Off-Market
					<span class="ml-2 font-normal">Pilar</span>
				</CardTitle>
			</CardHeader>
			<CardContent
				class="px-5 pb-5 font-sans text-[13px] font-medium text-primary md:text-base"
			>
				<p>
					Explore oportunidades selecionadas a dedo, disponíveis apenas aqui.
				</p>
			</CardContent>
			<CardFooter class="px-5 pb-7">
				<div
					class="size-full max-h-[44px] max-w-[197px] md:max-h-[48px] md:max-w-[228px]"
				>
					<NuxtLink v-slot="{ href, navigate }" custom to="/off-market">
						<Button
							as="a"
							:href="href"
							size="md"
							variant="secondary"
							class="text-sm md:text-base"
							@click="handleOffMarketCardClicked(navigate)"
						>
							Imóveis Off-Market
							<IconMaterialSymbolsLightNorthEast class="size-5" />
						</Button>
					</NuxtLink>
				</div>
			</CardFooter>
		</Card>
	</div>
</template>
<script setup lang="ts">
import { getProvidedImageHandler, getUrlFromStaticDNS } from '~/utils';

const offMarketBus = useEventBus('cta_off_market_clicked');

function handleOffMarketCardClicked(navigate: () => void) {
	offMarketBus.emit('cta_off_market_clicked');
	navigate();
}
</script>
